import styled from "styled-components";
import React, { useState } from "react";
import { requestTranslation } from "@futures-platform/i18n";

const TranslationBtn = ({
  // color = '#b0b0b0',
  width = "39px",
  height = "39px",
  handler,
  isNewsBookMarked,
  widthOfView,
  newsData,
  isAuthed,
}) => {
  const [isHover, setIsHover] = useState(false);
  const isMobile = /Mobi/.test(window.navigator.userAgent);
  return (
    <FlagWrapper
      onMouseOver={() => {
        setIsHover(() => true);
      }}
      onMouseOut={() => {
        setIsHover(() => false);
      }}
      id="news-bookmark"
      onClick={handler}
      style={{
        // marginTop: widthOfView > 600 ? 0 : '8px',
        // marginTop: '4px',
        cursor: "pointer",
      }}
    >
      {!isAuthed ? (
        <svg
          width="36"
          height="36"
          viewBox="0 0 36 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-labelledby={requestTranslation("BookmarkSVG")}
          aria-describedby={requestTranslation("BookmarkSVG")}
        >
          <title>{requestTranslation("BookmarkSVG")}</title>
          <mask
            id="mask0_4093_1006"
            style={{
              maskType: "luminance",
            }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="36"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M36 18C36 27.9419 27.941 36 18.0006 36C8.05905 36 0 27.9419 0 18C0 8.05815 8.05905 0 18.0006 0C27.941 0 36 8.05815 36 18Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_4093_1006)">
            <rect width="36" height="36" fill="#E8EBEB" />
            <circle cx="18" cy="18" r="17" fill="white" />
          </g>
          <path
            d="M22.6464 10H13.3536C13.1272 10 12.9101 10.0899 12.75 10.25C12.5899 10.4101 12.5 10.6272 12.5 10.8536V25.2455C12.5 25.4085 12.5647 25.5647 12.6799 25.6799C12.8703 25.8703 13.1623 25.9146 13.4005 25.7892L17.5288 23.6164C17.6741 23.54 17.8358 23.5 18 23.5C18.1642 23.5 18.3259 23.54 18.4712 23.6164L22.5995 25.7892C22.8377 25.9146 23.1297 25.8703 23.3201 25.6799C23.4353 25.5647 23.5 25.4085 23.5 25.2455V22.25C23.5 21.8358 23.1642 21.5 22.75 21.5C22.3358 21.5 22 21.8358 22 22.25V23.5C22 23.7265 21.7587 23.8713 21.5588 23.7647L18.4706 22.1176C18.3258 22.0404 18.1641 22 18 22C17.8359 22 17.6742 22.0404 17.5294 22.1176L14.4412 23.7647C14.2413 23.8713 14 23.7265 14 23.5V12C14 11.7239 14.2239 11.5 14.5 11.5H21.5C21.7761 11.5 22 11.7239 22 12V12.25C22 12.6642 22.3358 13 22.75 13C23.1642 13 23.5 12.6642 23.5 12.25V12V10.8536C23.5 10.6272 23.4101 10.4101 23.25 10.25C23.0899 10.0899 22.8728 10 22.6464 10Z"
            fill="#637282"
          />
          <path d="M22 22.5V12H23.5V22.5H22Z" fill="#637282" />
        </svg>
      ) : (
        <>
          {!!isNewsBookMarked && (
            <>
              {!isHover || !!isMobile ? (
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-labelledby={requestTranslation("BookmarkSVG")}
                  aria-describedby={requestTranslation("BookmarkSVG")}
                >
                  <title>{requestTranslation("BookmarkSVG")}</title>
                  <mask
                    id="mask0_4093_1008"
                    style={{
                      maskType: "luminance",
                    }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="36"
                    height="36"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M36 18C36 27.9419 27.941 36 18.0006 36C8.05905 36 0 27.9419 0 18C0 8.05815 8.05905 0 18.0006 0C27.941 0 36 8.05815 36 18Z"
                      fill="white"
                    />
                  </mask>
                  <g mask="url(#mask0_4093_1008)">
                    <rect width="36" height="36" fill="#00C3FF" />
                    <circle cx="18" cy="18" r="17" fill="white" />
                  </g>
                  <path
                    d="M22.6464 10H13.3536C13.1272 10 12.9101 10.0899 12.75 10.25C12.5899 10.4101 12.5 10.6272 12.5 10.8536V25.2455C12.5 25.4085 12.5647 25.5647 12.6799 25.6799C12.8703 25.8703 13.1623 25.9146 13.4005 25.7892L17.5288 23.6164C17.6741 23.54 17.8358 23.5 18 23.5C18.1642 23.5 18.3259 23.54 18.4712 23.6164L22.5995 25.7892C22.8377 25.9146 23.1297 25.8703 23.3201 25.6799C23.4353 25.5647 23.5 25.4085 23.5 25.2455V22.25C23.5 21.8358 23.1642 21.5 22.75 21.5C22.3358 21.5 22 21.8358 22 22.25V23.5C22 23.7265 21.7587 23.8713 21.5588 23.7647L18.4706 22.1176C18.3258 22.0404 18.1641 22 18 22C17.8359 22 17.6742 22.0404 17.5294 22.1176L14.4412 23.7647C14.2413 23.8713 14 23.7265 14 23.5V12C14 11.7239 14.2239 11.5 14.5 11.5H21.5C21.7761 11.5 22 11.7239 22 12V12.25C22 12.6642 22.3358 13 22.75 13C23.1642 13 23.5 12.6642 23.5 12.25V12V10.8536C23.5 10.6272 23.4101 10.4101 23.25 10.25C23.0899 10.0899 22.8728 10 22.6464 10Z"
                    fill="#00C3FF"
                  />
                  <path d="M22 22.5V12H23.5V22.5H22Z" fill="#00C3FF" />
                </svg>
              ) : (
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-labelledby={requestTranslation("BookmarkSVG")}
                  aria-describedby={requestTranslation("BookmarkSVG")}
                >
                  <title>{requestTranslation("BookmarkSVG")}</title>
                  <mask
                    id="mask0_4093_1007"
                    style={{
                      maskType: "luminance",
                    }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="36"
                    height="36"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M36 18C36 27.9419 27.941 36 18.0006 36C8.05905 36 0 27.9419 0 18C0 8.05815 8.05905 0 18.0006 0C27.941 0 36 8.05815 36 18Z"
                      fill="white"
                    />
                  </mask>
                  <g mask="url(#mask0_4093_1007)">
                    <rect width="36" height="36" fill="#689AB9" />
                    <circle cx="18" cy="18" r="17" fill="white" />
                  </g>
                  <path
                    d="M22.6464 10H13.3536C13.1272 10 12.9101 10.0899 12.75 10.25C12.5899 10.4101 12.5 10.6272 12.5 10.8536V25.2455C12.5 25.4085 12.5647 25.5647 12.6799 25.6799C12.8703 25.8703 13.1623 25.9146 13.4005 25.7892L17.5288 23.6164C17.6741 23.54 17.8358 23.5 18 23.5C18.1642 23.5 18.3259 23.54 18.4712 23.6164L22.5995 25.7892C22.8377 25.9146 23.1297 25.8703 23.3201 25.6799C23.4353 25.5647 23.5 25.4085 23.5 25.2455V22.25C23.5 21.8358 23.1642 21.5 22.75 21.5C22.3358 21.5 22 21.8358 22 22.25V23.5C22 23.7265 21.7587 23.8713 21.5588 23.7647L18.4706 22.1176C18.3258 22.0404 18.1641 22 18 22C17.8359 22 17.6742 22.0404 17.5294 22.1176L14.4412 23.7647C14.2413 23.8713 14 23.7265 14 23.5V12C14 11.7239 14.2239 11.5 14.5 11.5H21.5C21.7761 11.5 22 11.7239 22 12V12.25C22 12.6642 22.3358 13 22.75 13C23.1642 13 23.5 12.6642 23.5 12.25V12V10.8536C23.5 10.6272 23.4101 10.4101 23.25 10.25C23.0899 10.0899 22.8728 10 22.6464 10Z"
                    fill="#689AB9"
                  />
                  <path d="M22 22.5V12H23.5V22.5H22Z" fill="#689AB9" />
                </svg>
              )}
            </>
          )}
          {!isNewsBookMarked && (
            <>
              {!isHover || !!isMobile ? (
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-labelledby={requestTranslation("BookmarkSVG")}
                  aria-describedby={requestTranslation("BookmarkSVG")}
                >
                  <title>{requestTranslation("BookmarkSVG")}</title>
                  <mask
                    id="mask0_4093_1006"
                    style={{
                      maskType: "luminance",
                    }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="36"
                    height="36"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M36 18C36 27.9419 27.941 36 18.0006 36C8.05905 36 0 27.9419 0 18C0 8.05815 8.05905 0 18.0006 0C27.941 0 36 8.05815 36 18Z"
                      fill="white"
                    />
                  </mask>
                  <g mask="url(#mask0_4093_1006)">
                    <rect width="36" height="36" fill="#E8EBEB" />
                    <circle cx="18" cy="18" r="17" fill="white" />
                  </g>
                  <path
                    d="M22.6464 10H13.3536C13.1272 10 12.9101 10.0899 12.75 10.25C12.5899 10.4101 12.5 10.6272 12.5 10.8536V25.2455C12.5 25.4085 12.5647 25.5647 12.6799 25.6799C12.8703 25.8703 13.1623 25.9146 13.4005 25.7892L17.5288 23.6164C17.6741 23.54 17.8358 23.5 18 23.5C18.1642 23.5 18.3259 23.54 18.4712 23.6164L22.5995 25.7892C22.8377 25.9146 23.1297 25.8703 23.3201 25.6799C23.4353 25.5647 23.5 25.4085 23.5 25.2455V22.25C23.5 21.8358 23.1642 21.5 22.75 21.5C22.3358 21.5 22 21.8358 22 22.25V23.5C22 23.7265 21.7587 23.8713 21.5588 23.7647L18.4706 22.1176C18.3258 22.0404 18.1641 22 18 22C17.8359 22 17.6742 22.0404 17.5294 22.1176L14.4412 23.7647C14.2413 23.8713 14 23.7265 14 23.5V12C14 11.7239 14.2239 11.5 14.5 11.5H21.5C21.7761 11.5 22 11.7239 22 12V12.25C22 12.6642 22.3358 13 22.75 13C23.1642 13 23.5 12.6642 23.5 12.25V12V10.8536C23.5 10.6272 23.4101 10.4101 23.25 10.25C23.0899 10.0899 22.8728 10 22.6464 10Z"
                    fill="#637282"
                  />
                  <path d="M22 22.5V12H23.5V22.5H22Z" fill="#637282" />
                </svg>
              ) : (
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-labelledby={requestTranslation("BookmarkSVG")}
                  aria-describedby={requestTranslation("BookmarkSVG")}
                >
                  <title>{requestTranslation("BookmarkSVG")}</title>
                  <mask
                    id="mask0_4093_1007"
                    style={{
                      maskType: "luminance",
                    }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="36"
                    height="36"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M36 18C36 27.9419 27.941 36 18.0006 36C8.05905 36 0 27.9419 0 18C0 8.05815 8.05905 0 18.0006 0C27.941 0 36 8.05815 36 18Z"
                      fill="white"
                    />
                  </mask>
                  <g mask="url(#mask0_4093_1007)">
                    <rect width="36" height="36" fill="#689AB9" />
                    <circle cx="18" cy="18" r="17" fill="white" />
                  </g>
                  <path
                    d="M22.6464 10H13.3536C13.1272 10 12.9101 10.0899 12.75 10.25C12.5899 10.4101 12.5 10.6272 12.5 10.8536V25.2455C12.5 25.4085 12.5647 25.5647 12.6799 25.6799C12.8703 25.8703 13.1623 25.9146 13.4005 25.7892L17.5288 23.6164C17.6741 23.54 17.8358 23.5 18 23.5C18.1642 23.5 18.3259 23.54 18.4712 23.6164L22.5995 25.7892C22.8377 25.9146 23.1297 25.8703 23.3201 25.6799C23.4353 25.5647 23.5 25.4085 23.5 25.2455V22.25C23.5 21.8358 23.1642 21.5 22.75 21.5C22.3358 21.5 22 21.8358 22 22.25V23.5C22 23.7265 21.7587 23.8713 21.5588 23.7647L18.4706 22.1176C18.3258 22.0404 18.1641 22 18 22C17.8359 22 17.6742 22.0404 17.5294 22.1176L14.4412 23.7647C14.2413 23.8713 14 23.7265 14 23.5V12C14 11.7239 14.2239 11.5 14.5 11.5H21.5C21.7761 11.5 22 11.7239 22 12V12.25C22 12.6642 22.3358 13 22.75 13C23.1642 13 23.5 12.6642 23.5 12.25V12V10.8536C23.5 10.6272 23.4101 10.4101 23.25 10.25C23.0899 10.0899 22.8728 10 22.6464 10Z"
                    fill="#689AB9"
                  />
                  <path d="M22 22.5V12H23.5V22.5H22Z" fill="#689AB9" />
                </svg>
              )}
            </>
          )}
        </>
      )}
    </FlagWrapper>
  );
};

export default TranslationBtn;

const FlagWrapper = styled.div`
  background: transparent;
  // border-radius: 100%;
  // box-shadow: 0px 2px 3px 0px rgb(0 0 0 / 10%);
  // width: 36px;
  // height: 36px;
  // & svg:last-child {
  //   display: none;
  //   width: 0;
  //   height: 0;
  // }
  // &:hover svg:last-child {
  //   display: block;
  //   width: 36px;
  //   height: 36px;
  // }
  // &:hover svg:first-child {
  //   display: none;
  // }
`;

export const EditButton = styled.img`
  cursor: pointer;
  background-color: transparent;
  color: transparent;
  width: 150px;
  height: 30px;
`;
